module.exports = __webpack_public_path__ + "static/media/s5.828a1f9c.jpg";